module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('span', {
    staticClass: "hide-mobile"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'management.user.update-profile'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('generic.logout.buttons.profile')))])], 1), _vm._v(" "), _c('el-dropdown-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'management.user.change-password'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('generic.logout.buttons.changepassword')))])], 1), _vm._v(" "), (_vm.canChangePin) ? _c('el-dropdown-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'management.user.change-pincode'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('generic.logout.buttons.changepin')))])], 1) : _vm._e(), _vm._v(" "), (_vm.showLogout) ? _c('el-dropdown-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'logout'
      },
      "title": _vm.$t('generic.logout.buttons.logout'),
      "alt": _vm.$t('generic.logout.buttons.logout')
    }
  }, [_vm._v(_vm._s(_vm.$t('generic.logout.buttons.logout')))])], 1) : _vm._e(), _vm._v(" "), (_vm.user.canResetMfaSecret) ? _c('el-dropdown-item', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resetUserQrSecret(_vm.user.uuid)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('generic.logout.buttons.mfaResetQrSecret')))])]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d8d0f3d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dq-ui/packages/usermenu/src/usermenu.vue
// module id = 501
// module chunks = 36